import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { PlantBrief, PlantListSearchCriteria } from '../models';
import { getQueryStringFromObject } from '../../../../../common';
import { PlantEndpoint } from '../../../../constants';

@Injectable({
  providedIn: 'root',
})
export class PlantListService {
  constructor(private http: WrapperHttpService) {}

  getPlantList({ size, page, ...partnerFilterView }: PlantListSearchCriteria): Observable<PlantBrief[]> {
    const url = `${API_URL}${PlantEndpoint.Base}${PlantEndpoint.Filter}?${getQueryStringFromObject({ page, size })}`;
    return this.http.withLoading().post<PlantBrief[]>(url, partnerFilterView);
  }
}
